import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserInfo } from "../utils/utils";

const RouteGuard = ({ children }) => {
  const user = getUserInfo();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      user?.passwordChangeNeeded &&
      location.pathname !== "/account/change-password"
    ) {
      navigate("/account/change-password");
    }
  }, [user, location, navigate]);

  return children;
};

export default RouteGuard;
